import React from "react"; // eslint-disable-line no-unused-vars
import FindMyMSLForm from "./FindMyMSLForm";
import "../css/forms/default-forms.css";
import { connect } from "react-redux";
import { addNotification as notify } from "reapop";
import CountryAwareComponent from "./CountryAwareComponent";
import HeroImage from "./HeroImage";
import { v4 as uuidv4 } from "uuid";
import { triggerSSO } from "./InitiateSSO";
import { api } from "./index.api";
import Footer from "./Footer";
import { isMobileDevice } from "../functions.js";
import { Link } from "react-router-dom";
import imgHeaderFindMyMslMobile from "./assets/img_header_find_my_msl_mobile.jpg";
import imgHeaderFindMyMsl from "./assets/img_header_find_my_msl.jpg";
import { Checkmark } from "./assets/Checkmark";
import FindMyMSLMeetingRequest from "./FindMyMSLMeetingRequest";
import { REF_DATA } from "../constants";

class FindMyMSL extends CountryAwareComponent {
  constructor(props) {
    super(props);

    this.state = {
      searchItems: [],
      searching: false,
      requestMSL: null,
      formRefreshKey: null,
    };

    this.componentName = "FindMyMSL";
    this.onSubmit = this.onSubmit.bind(this);
    this.showMessage = false;
    this.formRef = React.createRef();
  }

  onSubmit(postData, callbackFn) {
    this.setState({ searchItems: [] }, function () {
      this.forceUpdate();
    });

    this.showMessage = false;
    this.setState({ searching: true });

    api.findMyMSL(
      {
        therapeuticArea: postData.therapeuticArea,
        subTherapeuticArea: postData.subTherapeuticArea,
        diseaseState: postData.diseaseState,
        zipAreaCode: postData.zipAreaCode,
      },
      this._searchSuccessHandler.bind(this, postData),
      this._searchFailureHandler.bind(this)
    );
  }

  clearSearchResult = () => {
    this.showMessage = false;
    this.setState({ searchItems: [] }, function () {
      this.forceUpdate();
    });
  };

  _searchSuccessHandler = (postData, response) => {
    if (response.status === 200) {
      response.json().then((responseJson) => {
        const searchItems = responseJson;
        if (searchItems.length === 0) {
          this.showMessage = true;
        }

        this.setState({ searchItems: searchItems, searching: false });

        if (typeof ABVMetrics !== "undefined") {
          const formmd = {
            frmType: "find my msl",
            frmStage: "final-complete",
            formattr: {
              therapeutic_area: postData.therapeuticArea,
              sub_therapeutic_area: postData.subTherapeuticArea,
              disease_state: postData.diseaseState,
              zipcode: postData.zipAreaCode,
            },
            formOutput: searchItems,
          };
          ABVMetrics.sendFormAnalytics(formmd); // eslint-disable-line no-undef
        }
      });
    } else if (response.status === 401) {
      this._showNotification(
        "Error",
        "You are not authorized to perform this action. Please log in again.",
        "error"
      );
      setTimeout(() => triggerSSO(this.props.pageContent.content.lang), 3000);
    } else {
      this._showNotification(
        "Error",
        "Error occurred while submitting query",
        "error"
      );
      this.setState({ searching: false });
    }
  };

  _searchFailureHandler = (error) => {
    /* eslint-disable-line */
    this.setState({ searching: false });
    this._showNotification("Error", "Unexpected error occurred!!", "error");
  };

  setSearchAuditId = (searchAuditId) => {
    this.setState({ searchAuditId });
  };

  _showNotification = (title, message, status) => {
    const { notify } = this.props;
    notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };

  handleMeetingRequestClick = (msl) => this.setState({ requestMSL: msl });

  closeMeetingModal = () =>
    this.setState({ requestMSL: null, formRefreshKey: uuidv4() });

  handleMeetingRequestSubmitted = (msl) => {
    if (!msl) {
      return;
    }
    const searchItems = this.state.searchItems.map((item) =>
      item.id === msl.id ? { ...item, submitted: true } : item
    );
    this.setState({ searchItems });
  };

  formatPhoneNumber = (str) => {
    let cleaned = ("" + str).replace(/\D/g, "");
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      let intlCode = match[1] ? "+1 " : "";
      return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
    }
    return str;
  };

  render() {
    const languageContent = this.props.pageContent.content;
    const referenceData = this.props.referenceData
      ? this.props.referenceData
      : [];
    const jsx = (
      <div className="page-container">
        <div className="page-content">
          <HeroImage
            title={languageContent.module.findMyMSL.title}
            imageMobile={imgHeaderFindMyMslMobile}
            imageDesktop={imgHeaderFindMyMsl}
          />
          <div className="search-container">
            <div className="container">
              <FindMyMSLForm
                ref={this.formRef}
                clearSearchResult={this.clearSearchResult}
                submit={this.onSubmit}
                searching={this.state.searching}
              />
              <div className="findmymsl-container">
                <div
                  className="container"
                  style={{ padding: "0px", margin: "0px" }}
                >
                  {this.showMessage ? (
                    <div className="row">
                      <div
                        id="mslNotFound"
                        className="col-lg-6 findmymsl-not-found"
                        style={{
                          margin: isMobileDevice ? "10px" : "",
                        }}
                      >
                        <table style={{ margin: "8px 0px 8px 0px" }}>
                          <tbody>
                            <tr>
                              <td>
                                <span
                                  style={{
                                    color: "#222222",
                                    fontSize: "28px",
                                    padding: "0px 10px 0px 0px",
                                  }}
                                  className="fa fa-info-circle"
                                />
                              </td>
                              <td>
                                {languageContent.module.findMyMSL.noDataText.replace(
                                  "[SUBMIT-INQUIRY].",
                                  ""
                                )}
                                <Link
                                  className="anchor-link"
                                  data-tag="track-link"
                                  data-analytics-text="Submit Inquiry"
                                  to="/submit-inquiry"
                                >
                                  {
                                    languageContent.module.findMyMSL
                                      .submitInquiry
                                  }
                                </Link>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/*  SEARCH RESULTS  */}
                  <div className="row">
                    {this.state.searchItems &&
                    this.state.searchItems.length > 0 ? (
                      this.state.searchItems.map((item, i) => (
                        <div
                          key={item.id}
                          id={`mslCard-${i}`}
                          className="col-lg-4 col-xl-4"
                          style={{ marginBottom: "20px" }}
                        >
                          <div
                            style={{
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                padding: "16px",
                                background: "rgba(47, 158, 206, 0.03)",
                                border: "1px solid #2F9ECE",
                                borderRadius: "6px",
                                flex: "1 0 auto",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  height: "100%",
                                }}
                              >
                                <div>
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td colSpan={2}>
                                          <span
                                            style={{
                                              fontSize: "18px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {`${item.firstName} ${item.lastName}`}
                                          </span>
                                        </td>
                                      </tr>

                                      {item.phone.length > 1 ? (
                                        <tr>
                                          <td
                                            style={{
                                              padding: "5px 10px 5px 0px",
                                            }}
                                          >
                                            <span
                                              style={{
                                                color: "#2F9ECE",
                                                fontSize: "22px",
                                                padding: "5px 0px 0px 0px",
                                              }}
                                              className="fa fa-phone fa-lg"
                                            />
                                          </td>
                                          <td
                                            style={{
                                              color: "#2F9ECE",
                                              fontSize: "16px",
                                              padding: "5px 0px 5px 0px",
                                            }}
                                          >
                                            <a
                                              className="anchor-link"
                                              style={{ whiteSpace: "initial" }}
                                              href={`tel:${item.phone}`}
                                            >
                                              {this.formatPhoneNumber(
                                                item.phone + ""
                                              )}
                                            </a>
                                          </td>
                                        </tr>
                                      ) : null}
                                      {item.email_address ? (
                                        <tr>
                                          <td
                                            style={{
                                              padding: "5px 10px 5px 0px",
                                            }}
                                          >
                                            <span
                                              style={{
                                                color: "#2F9ECE",
                                                fontSize: "22px",
                                                padding: "5px 0px 0px 0px",
                                              }}
                                              className="fa fa-envelope fa-lg"
                                            />
                                          </td>
                                          <td
                                            style={{
                                              color: "#2F9ECE",
                                              fontSize: "16px",
                                              padding: "5px 0px 5px 0px",
                                            }}
                                          >
                                            <a
                                              className="anchor-link"
                                              style={{ whiteSpace: "initial" }}
                                              href={`mailto:${item.email_address}?subject=Medical Info Portal Inquiry`}
                                            >
                                              {item.email_address}
                                            </a>
                                          </td>
                                        </tr>
                                      ) : null}
                                      {item.msldoc ? (
                                        <tr>
                                          <td
                                            style={{
                                              padding: "5px 10px 5px 0px",
                                            }}
                                          >
                                            <span
                                              style={{
                                                color: "#2F9ECE",
                                                fontSize: "22px",
                                                padding: "5px 0px 0px 0px",
                                              }}
                                              className="fa fa-file fa-lg"
                                            />
                                          </td>
                                          <td
                                            style={{
                                              color: "#2F9ECE",
                                              fontSize: "16px",
                                              padding: "5px 0px 5px 0px",
                                            }}
                                          >
                                            <a
                                              className="anchor-link"
                                              style={{ whiteSpace: "initial" }}
                                              href={`${item.msldoc}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              Click Here For More Information
                                            </a>
                                          </td>
                                        </tr>
                                      ) : null}
                                      {item.mslvideo ? (
                                        <tr>
                                          <td
                                            style={{
                                              padding: "5px 10px 5px 0px",
                                            }}
                                          >
                                            <span
                                              style={{
                                                color: "#2F9ECE",
                                                fontSize: "22px",
                                                padding: "5px 0px 0px 0px",
                                              }}
                                              className="fa fa-video-camera fa-lg"
                                            />
                                          </td>
                                          <td
                                            style={{
                                              color: "#2F9ECE",
                                              fontSize: "16px",
                                              padding: "5px 0px 5px 0px",
                                            }}
                                          >
                                            <a
                                              className="anchor-link"
                                              style={{ whiteSpace: "initial" }}
                                              href={`${item.mslvideo}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              Click Here For Video
                                            </a>
                                          </td>
                                        </tr>
                                      ) : null}
                                    </tbody>
                                  </table>
                                </div>
                                {item.email_address && !item.submitted && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <button
                                      id="requestMeetingBtn"
                                      className="btn btn-info btn-lg-wide mobile-btn btn-rounded"
                                      style={{
                                        cursor: "pointer",
                                        marginTop: "16px",
                                      }}
                                      onClick={() =>
                                        this.handleMeetingRequestClick(item)
                                      }
                                    >
                                      Request Meeting
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                            {item.submitted ? (
                              <div
                                id="feedback-success"
                                className="feedback-success"
                              >
                                <Checkmark
                                  styles={{
                                    minWidth: "24px",
                                    minHeight: "24px",
                                  }}
                                />
                                <span style={{ marginLeft: "0.5rem" }}>
                                  Thank you! Your meeting request has been sent
                                  to the MSL.
                                </span>
                              </div>
                            ) : (
                              <div className="feedback-placeholder" />
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div id="paddingDiv" style={{ paddingTop: "205px" }}>
                        &nbsp;
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <FindMyMSLMeetingRequest
            isOpen={!!this.state.requestMSL}
            key={this.state.formRefreshKey}
            msl={this.state.requestMSL || {}}
            onClose={this.closeMeetingModal}
            searchFormFields={this.formRef}
            referenceData={referenceData}
            onSubmitted={() =>
              this.handleMeetingRequestSubmitted(this.state.requestMSL)
            }
            _showNotification={this._showNotification}
          />
        </div>
        <Footer />
      </div>
    );
    return this.countriesMatched() ? jsx : null;
  }
}

function mapStateToProps(state) {
  return {
    referenceData: state.referenceData.find(
      (category) => category.type === REF_DATA
    ).referenceData,
    pageContent: state.pageContent,
    permissions: state.permissions,
  };
}

export default connect(mapStateToProps, { notify })(FindMyMSL);



// WEBPACK FOOTER //
// ./src/mi-app/FindMyMSL.js